import { IChangeTimeBlocksRequest } from "../entities-generated/models/time-block/change-time-blocks-request";
import { ICreateTimeBlocksRequest } from "../entities-generated/models/time-block/create-time-blocks-request";
import { IReserveTimeBlocksRequest } from "../entities-generated/models/time-block/reserve-time-blocks-request";
import { IReserveTimeBlocksResponse } from "../entities-generated/models/time-block/reserve-time-blocks-response";
import { ITimeBlockListing } from "../entities-generated/models/time-block/time-block-listing";
import { ApiClient } from "./admin-api-client";

class AdminTimeBlockApiClientClass {
  public createTimeBlocks(request: ICreateTimeBlocksRequest) {
    return ApiClient.post<ITimeBlockListing[]>('appointments', request);
  }

  public getInstallationDateOptions(projectId: string) {
    return ApiClient.get<ITimeBlockListing[]>(`appointments/available/project/${projectId}/admin`);
  }

  public getManageableTimeBlocks() {
    return ApiClient.get<ITimeBlockListing[]>(`appointments/list`);
  }

  public reserveInstallationDate(request: IReserveTimeBlocksRequest) {
    return ApiClient.patch<IReserveTimeBlocksResponse>(`appointments/reserve`, request);
  }

  public updateTimeBlocks(request: IChangeTimeBlocksRequest) {
    return ApiClient.patch<ITimeBlockListing[]>('appointments', request);
  }
}

export const AdminTimeBlockApiClient = new AdminTimeBlockApiClientClass();